import { gql } from '__generated__';

export default gql(`
  mutation EditEmailForOrder($input: EditEmailForOrderInput!) {
    editEmailForOrder(input: $input) {
      id
    }
  }
`);
